import React from "react";

import { AudioState, Preview } from "@creatomate/preview";

import ElementStartEnd from "components/stories/video-studio/common/ElementStartEnd";
import AudioFade from "components/stories/video-studio/common/properties/audio/AudioFade";
import Volume from "components/stories/video-studio/common/properties/Volume";
import TrimStart from "components/stories/video-studio/common/properties/TrimStart";

interface AudioFieldsProps {
  activeElement: AudioState;
  preview: Preview;
}

const AudioFields: React.FC<AudioFieldsProps> = ({ activeElement, preview }) => (
  <div className="Audios-Container">
    <ElementStartEnd activeElement={activeElement} preview={preview} />
    <div className="Captions-Time-Fade">
      <AudioFade activeElement={activeElement} fadeProperty="audio_fade_in" preview={preview} />
      <AudioFade activeElement={activeElement} fadeProperty="audio_fade_out" preview={preview} />
    </div>
    <Volume activeElement={activeElement} preview={preview} />
    <TrimStart activeElement={activeElement} preview={preview} />
  </div>
);

export default AudioFields;
